import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Card } from 'primereact/card';
import { DashboardService } from '../services/DashboardService';
import { Skeleton } from 'primereact/skeleton';
import { Chart } from 'primereact/chart';

const Dashboard = () => {
    const { user } = useAuth();
    const [resumen, setResumen] = useState(null);
    const [loading, setLoading] = useState(true);
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const fetchResumen = async () => {
            try {
                // Obtener idEmpresa del user context dinamicamente, por defecto 1
                const idEmpresa = user?.idEmpresa || 1;
                const response = await DashboardService.getResumen(idEmpresa);  
                setResumen(response.data);
                
                // Set Chart config si los datos existen
                if(response.data && response.data.graficoComparativo) {
                    const data = {
                        labels: ['Mes Anterior', 'Mes Actual'],
                        datasets: [
                            {
                                label: 'Ventas (S/)',
                                backgroundColor: ['#3b82f6', '#22c55e'],
                                data: [
                                    response.data.graficoComparativo.ventasMesAnterior || 0,
                                    response.data.graficoComparativo.ventasMesActual || 0
                                ]
                            }
                        ]
                    };
                    const options = {
                        scales: {
                            y: {
                                beginAtZero: true
                            }
                        }
                    };
                    setChartData(data);
                    setChartOptions(options);
                }

            } catch (error) {
                console.error("Error cargando resumen", error);
            } finally {
                setLoading(false);
            }
        };

        fetchResumen();
    }, [user]);

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card shadow-2 border-round-xl mb-4">
                    <h2 className="text-3xl font-bold text-900 mb-2">Bienvenido, {user?.nombre || user?.username}</h2>
                    <p className="text-500 text-lg m-0">Aquí está el resumen de operaciones.</p>
                </div>
            </div>

            <div className="col-12 md:col-6 lg:col-3">
                <Card className="shadow-2 border-round-xl border-left-3 border-blue-500">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Ventas de Hoy</span>
                            {loading ? <Skeleton width="5rem" height="2rem" /> : <div className="text-900 font-medium text-xl">S/ {Number(resumen?.totalVentasHoy || 0).toFixed(2)}</div>}
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}> 
                            <i className="pi pi-shopping-cart text-blue-500 text-xl"></i>
                        </div>
                    </div>
                    {loading ? <Skeleton width="10rem" /> : <span className="text-green-500 font-medium">{resumen?.cantidadVentasHoy || 0} nuevas </span>}      
                    <span className="text-500">transacciones</span>
                </Card>
            </div>

            <div className="col-12 md:col-6 lg:col-3">
                <Card className="shadow-2 border-round-xl border-left-3 border-orange-500">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Catálogo</span>
                            {loading ? <Skeleton width="5rem" height="2rem" /> : <div className="text-900 font-medium text-xl">{resumen?.totalProductos || 0}</div>}
                        </div>
                        <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                            <i className="pi pi-box text-orange-500 text-xl"></i>
                        </div>
                    </div>
                    <span className="text-500">Productos registrados</span>     
                </Card>
            </div>

            <div className="col-12 md:col-6 lg:col-3">
                <Card className="shadow-2 border-round-xl border-left-3 border-red-500">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Impuestos a Pagar (Mes)</span>
                            {loading ? <Skeleton width="5rem" height="2rem" /> : <div className="text-900 font-medium text-xl">S/ {Number(resumen?.impuestosMesActual || 0).toFixed(2)}</div>}
                        </div>
                        <div className="flex align-items-center justify-content-center bg-red-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                            <i className="pi pi-chart-pie text-red-500 text-xl"></i>
                        </div>
                    </div>
                    <span className="text-500">Calculado sobre Facturas/Boletas</span>       
                </Card>
            </div>

            <div className="col-12 md:col-6 lg:col-3">
                <Card className="shadow-2 border-round-xl border-left-3 border-purple-500">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Movimientos Kardex</span>
                            {loading ? <Skeleton width="5rem" height="2rem" /> : <div className="text-900 font-medium text-xl">{resumen?.totalMovimientos || 0}</div>}
                        </div>
                        <div className="flex align-items-center justify-content-center bg-purple-100 border-round" style={{ width: '2.5rem', height: '2.5rem' }}>
                            <i className="pi pi-arrows-h text-purple-500 text-xl"></i>
                        </div>
                    </div>
                    <span className="text-500">Flujo de inventario</span>       
                </Card>
            </div>

            {/* Nuevo Bloque Gráfico */}
            <div className="col-12 md:col-12 lg:col-12 mt-4">
                <Card title="Comparativa de Ventas (Mensual)" className="shadow-2 border-round-xl border-top-3 border-primary">
                    {loading ? (
                       <Skeleton width="100%" height="300px" />
                    ) : (
                       <Chart type="bar" data={chartData} options={chartOptions} />
                    )}
                </Card>
            </div>

        </div>
    );
};

export default Dashboard;
